/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '../util/cleanUpResponse';

export default async function GetExternalUserDetailsByID(id, isSelfService) {
  const response = await $.soap({
    body: {
      GetExternalUserDetailsByID: {
        $xmlns: 'http://dla.mil/ems/bpm/user',
        ID: id,
        isSelfService
      }
    },
    blueprintArrays: ['GetExternalUserDetailsByIDResponse.UserDetails.Commands.ExternalUserCommand'],
    blueprint: {
      id: '$..ID',
      firstName: '$..FirstName',
      lastName: '$..LastName',
      email: '$..Email',
      telephone: '$..Telephone',
      actingAsCommandId: '$..ActingAsCommandID',
      commandName: '$..CommandName',
      isAuthorized: '$..IsAuthorized',
      otdsUserId: '$..OTDSUserID',
      branchName: '$..BranchName',
      isCACLogin: '$..IsCACLogin',
      commands: [
        '$..Commands.ExternalUserCommand',
        {
          id: '$..CommandID',
          name: '$..CommandName',
          approvalStatusId: '$.ApprovalStatusID',
          serviceBranchID: '$..ServiceBranchID',
          serviceBranchName: '$..ServiceBranchName',
          regionName: '$..RegionName',
          dodac: '$..DODAC',
          status: '$..Status',
          requestedOn: '$..RequestedOn',
          decidedOn: '$..DecidedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response;
}
